module.exports = __webpack_public_path__ + "static/media/post-bg.b7cb6307.jpg";